<template>
  <div ref="domRef" :class="['base-card-info', marginBottom ? 'mb-0' : '']">
    <div class="info-card-title">
      开户许可证信息
    </div>
    <change-record-container>
      <template #before>
        <div class="left-list gap-y-[14px]">
          <div
            v-if="isTypeEqual 
              ? !deepEqualField(baseInfo?.pre?.companyLicense?.licenseType, baseInfo?.post?.companyLicense?.licenseType) 
              : true" 
            class="item"
          >
            <div class="label">
              账户类型
            </div>
            <div class="value">
              {{ isNull(baseInfo?.pre?.companyLicense?.licenseType) ? '--' : bindingTypeLabel[baseInfo?.pre?.companyLicense?.licenseType] }}
            </div>
          </div>
          
          <div
            v-if="isTypeEqual ?  
              isPreLegalPerson ? !deepEqualField(baseInfo?.pre?.companyLicense?.bankPhone, baseInfo?.post?.companyLicense?.bankPhone)
              : !deepEqualField(baseInfo?.pre?.companyLicense?.phoneNo, baseInfo?.post?.companyLicense?.phoneNo) 
              : true"
            class="item"
          >
            <div class="label">
              银行预留手机号
            </div>
            <div class="value">
              {{ isPreLegalPerson ? isNull(baseInfo?.pre?.companyLicense?.bankPhone) ? '--' 
                : baseInfo?.pre?.companyLicense?.bankPhone 
                : isNull(baseInfo?.pre?.companyLicense?.phoneNo) ? '--' 
                  : baseInfo?.pre?.companyLicense?.phoneNo }}
            </div>
          </div>
          <div
            v-if="isTypeEqual 
              ? !deepEqualField(baseInfo?.pre?.companyLicense?.bankName, baseInfo?.post?.companyLicense?.bankName) 
              : true" 
            class="item"
          >
            <div class="label">
              开户银行
            </div>
            <div class="value">
              {{ isNull(baseInfo?.pre?.companyLicense?.bankName) ? '--' : baseInfo?.pre?.companyLicense?.bankName }}
            </div>
          </div>
          <div
            v-if="isTypeEqual ? 
              isPreLegalPerson ? !deepEqualField(baseInfo?.pre?.companyLicense?.personBankAccount , baseInfo?.post?.companyLicense?.personBankAccount )
              : !deepEqualField(baseInfo?.pre?.companyLicense?.bankAccount,baseInfo?.post?.companyLicense?.bankAccount)
              : true" 
            class="item"
          >
            <div class="label">
              银行账号
            </div>
            <div class="value">
              {{ isPreLegalPerson ? isNull(baseInfo?.pre?.companyLicense?.personBankAccount) ? '--' 
                : baseInfo?.pre?.companyLicense?.personBankAccount 
                : isNull(baseInfo?.pre?.companyLicense?.bankAccount) ? '--' 
                  : baseInfo?.pre?.companyLicense?.bankAccount }}
            </div>
          </div>
          <div 
            v-if="isTypeEqual ? 
              isPreLegalPerson ? !deepEqualField(baseInfo?.pre?.companyLicense?.bankCardUrl, baseInfo?.post?.companyLicense?.bankCardUrl)
              : !deepEqualField(baseInfo?.pre?.companyLicense?.licenseUrl, baseInfo?.post?.companyLicense?.licenseUrl)
              : true" 
            class="item"
          >
            <div class="label">
              {{ isPreLegalPerson ? '法定代表人银行卡' : '银行开户许可证' }}
            </div>
            <div class="value">
              <div v-if="!isPreLegalPerson? baseInfo?.pre?.companyLicense?.licenseUrl : baseInfo?.pre?.companyLicense?.bankCardUrl" class="business-license-box">
                <img
                  :src="!isPreLegalPerson? baseInfo?.pre?.companyLicense?.licenseUrl : baseInfo?.pre?.companyLicense?.bankCardUrl"
                >
              </div>
              <div v-else class="business-license-box" />
            </div>
          </div>
        </div>
      </template>
      <template #after>
        <div class="left-list gap-y-[14px]">
          <div
            v-if="isTypeEqual 
              ? !deepEqualField(baseInfo?.pre?.companyLicense?.licenseType, baseInfo?.post?.companyLicense?.licenseType) 
              : true" 
            class="item"
          >
            <div class="label">
              账户类型
            </div>
            <div class="value">
              {{ isNull(baseInfo?.post?.companyLicense?.licenseType) ? '--' : bindingTypeLabel[baseInfo?.post?.companyLicense?.licenseType] }}
            </div>
          </div>
          <div
            v-if="isTypeEqual ?  
              isPostLegalPerson ? !deepEqualField(baseInfo?.pre?.companyLicense?.bankPhone, baseInfo?.post?.companyLicense?.bankPhone)
              : !deepEqualField(baseInfo?.pre?.companyLicense?.phoneNo, baseInfo?.post?.companyLicense?.phoneNo) 
              : true"
            class="item"
          >
            <div class="label">
              银行预留手机号
            </div>
            <div class="value">
              {{ isPostLegalPerson ? isNull(baseInfo?.post?.companyLicense?.bankPhone) ? '--' 
                : baseInfo?.post?.companyLicense?.bankPhone 
                : isNull(baseInfo?.post?.companyLicense?.phoneNo) ? '--' 
                  : baseInfo?.post?.companyLicense?.phoneNo }}
            </div>
          </div>
          <div
            v-if="isTypeEqual 
              ? !deepEqualField(baseInfo?.pre?.companyLicense?.bankName, baseInfo?.post?.companyLicense?.bankName) 
              : true" 
            class="item"
          >
            <div class="label">
              开户银行
            </div>
            <div class="value">
              {{ isNull(baseInfo?.post?.companyLicense?.bankName) ? '--' : baseInfo?.post?.companyLicense?.bankName }}
            </div>
          </div>
          <div
            v-if="isTypeEqual ? 
              isPostLegalPerson ? !deepEqualField(baseInfo?.pre?.companyLicense?.personBankAccount , baseInfo?.post?.companyLicense?.personBankAccount )
              : !deepEqualField(baseInfo?.pre?.companyLicense?.bankAccount,baseInfo?.post?.companyLicense?.bankAccount)
              : true" 
            class="item"
          >
            <div class="label">
              银行账号
            </div>
            <div class="value">
              {{ isPostLegalPerson ? isNull(baseInfo?.post?.companyLicense?.personBankAccount) ? '--' 
                : baseInfo?.post?.companyLicense?.personBankAccount 
                : isNull(baseInfo?.post?.companyLicense?.bankAccount) ? '--' 
                  : baseInfo?.post?.companyLicense?.bankAccount }}
            </div>
          </div>
          <div 
            v-if="isTypeEqual ? 
              isPostLegalPerson ? !deepEqualField(baseInfo?.pre?.companyLicense?.bankCardUrl, baseInfo?.post?.companyLicense?.bankCardUrl)
              : !deepEqualField(baseInfo?.pre?.companyLicense?.licenseUrl, baseInfo?.post?.companyLicense?.licenseUrl)
              : true" 
            class="item"
          >
            <div class="label">
              {{ isPostLegalPerson ? '法人银行卡' : '银行开户许可证' }}
            </div>
            <div class="value">
              <div v-if="!isPostLegalPerson? baseInfo?.post?.companyLicense?.licenseUrl : baseInfo?.post?.companyLicense?.bankCardUrl" class="business-license-box">
                <img
                  :src="!isPostLegalPerson? baseInfo?.post?.companyLicense?.licenseUrl : baseInfo?.post?.companyLicense?.bankCardUrl"
                >
              </div>
              <div v-else class="business-license-box" />
            </div>
          </div>
        </div>
      </template>
    </change-record-container>
  </div>
</template>

<script setup lang="ts">
import { deepEqualField, isNull } from '@core/tools';
import changeRecordContainer from './change-record-container.vue';
import { useElementImgPreview } from '@vue3/components';
import { ICompanyChangeRecord } from '@core/main/types';
import { computed, inject, Ref, ref } from 'vue';
import { EBindingType, bindingTypeLabel } from '../../binding-card-form/type';

defineOptions({ name: 'BindingCardInfo' }); // 账户中心 - 开户许可证信息

const domRef = ref<HTMLDivElement>();

useElementImgPreview(domRef);

const isPreLegalPerson = computed(() => baseInfo?.value?.pre?.companyLicense?.licenseType === EBindingType.Personal);
const isPostLegalPerson = computed(() => baseInfo?.value?.post?.companyLicense?.licenseType === EBindingType.Personal);
const isTypeEqual = computed(() => isPreLegalPerson.value === isPostLegalPerson.value);

defineProps({
  marginBottom: {
    type: Boolean,
    default: false,
  },
});

const baseInfo = inject<Ref<ICompanyChangeRecord>>('baseInfo');
</script>
